import angular from 'angular';
import ptzCircles from './PTZCirclesComponent';
import ptzGrid from './PTZGridComponent';

export default angular
  .module('petroCloud.dashboard.cameraPanel.ptz', [])
  .component(ptzCircles.name, ptzCircles)
  .component(ptzGrid.name, ptzGrid)
  .name;
